'use strict';

var _ = require('lodash');
var OverbookingService = function OverbookingService(restangular, configurationService) {
  var service = restangular.service('domain/flights/showUpReinitialization');
  function reinitializeFromStatusScreen(rows) {
    return reinitialize(prepareRequestParams(rows));
  }
  function reinitialize(requestParams) {
    return service.post(requestParams);
  }
  function prepareRequestParams(preparedData) {
    var requestParams = {
      queueElements: []
    };
    _.forEach(preparedData, function (row) {
      var request = {
        marketOrigin: row.origin,
        marketDestination: row.destination,
        startDepartureDate: row.startDepartureDate.toISOString(),
        endDepartureDate: row.endDepartureDate.toISOString(),
        carrier: configurationService.getHostCarrier(),
        calendarName: 'ReInitShowup'
      };
      requestParams.queueElements.push(request);
    });
    return requestParams;
  }
  return {
    reinitializeFromStatusScreen: reinitializeFromStatusScreen
  };
};
OverbookingService.$inject = ['Restangular', 'ConfigurationService'];
module.exports = OverbookingService;